<template>
  <div class="py-2 grid grid-cols-12 items-center">
    <div class="col-span-1 flex flex-col">
      <button class="flex justify-center focus:outline-none" @click="$emit('up')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 15l7-7 7 7"
          />
        </svg>
      </button>
      <button class="flex justify-center focus:outline-none" @click="$emit('down')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
    </div>
    <p class="col-span-3 text-sm pr-2" v-html="accounts" />
    <p class="col-span-3 text-sm pr-2">
      {{ instruction.way.label }}
      <span v-if="instruction.extra"><br/>{{ instruction.extra.label }}</span>
    </p>
    <p class="col-span-4 text-sm pr-2">{{ instruction.until.label }}</p>
    <div class="col-span-1 flex items-center space-x-2">
      <button class="focus:outline-none" @click="$emit('edit')">
       <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <!-- eslint-disable max-len -->
          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
          <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
          <!-- eslint-enable max-len -->
        </svg>
      </button>
      <button class="focus:outline-none" @click="$emit('delete')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 text-red-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <!-- eslint-disable-next-line max-len -->
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-instruction',
  props: {
    instruction: {
      type: Object,
    },
  },
  computed: {
    accounts() {
      let output = '';
      this.instruction.accounts.ruleAccounts.forEach((account) => {
        output += `${account.member.name}<br/> - ${account.identifier}<br/>`;
      });
      return output;
    },
  },
};
</script>
